import httpService from "./httpService.js"

export const getAvailableMaterialsService = (page, limit, q, category, checkBoxesArray) => {
    let urlString = `/shop_admin/material_list/?page=${page}&page_size=${limit}${q ? `&search=${q}` : ""}${category ? `&persian_group=${category}` : ""}`;
    for (let item of checkBoxesArray) {
        if (item.checked) {
            urlString += `&${item.value}=0`;
        }
    }
    return httpService(urlString, "get");
}

export const getSingleMaterialService = (materialId) => {
    return httpService(`/shop_admin/material_admin_panel/${materialId}/`, "get");
}

export const addNewMaterialService = (data) => {
    return httpService("/shop_admin/material_admin_panel/", "post", data);
}

export const editMaterialService = (materialId, data) => {
    return httpService(`/shop_admin/material_admin_panel/${materialId}/`, "patch", data);
}

export const deleteMaterialService = (materialId) => {
    return httpService(`/shop_admin/material_admin_panel/${materialId}/`, "delete");
}

export const getAllMaterialPersianGroupsService = () => {
    return httpService("/shop_admin/get_material_group/", "get");
}

export const getMaterialIndex = () => {
    return httpService("/shop_admin/rebuild_material_index/", "get");
}